const ListEmployees = () => import("../views/ListEmployees.vue");
const AddOrEditEmployee = () => import("../views/AddOrEditEmployee.vue");
const EditEmployee = () => import("../views/EditEmployee.vue");
const ProfileEmployee = () => import("../views/ProfileEmployee.vue");
const ReadFile = () => import("../views/readFile.vue");

export default [
  {
    path: "trainees/list",
    component: ListEmployees,
    meta: { requiresAuth: true },
    name: "trainees",
  },
  {
    path: "trainees/add",
    component: AddOrEditEmployee,
    meta: { requiresAuth: true },
    name: "trainees.add",
    props: true,
  },
 
  {
    path: "trainees/edit/:id",
    component: EditEmployee,
    meta: { requiresAuth: true },
    name: "trainees.edit",
    props: true,
  },
  {
    path: "trainees/show/:id",
    component: ProfileEmployee,
    meta: { requiresAuth: true },
    name: "trainees.show",
    props: true,
  },
  {
    path: 'trainees/document/:file',
    component: ReadFile,
    meta: { requiresAuth: true },
    name: 'Profile',
    props: true
  }
];
